import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { UnlockCandidateFromJobApply } from "./UnlockCandidateFromJobApplyAPI";

const initialState = {
    data: null,
    loading: false,
    error: null,
    successMessage: null
};

export const UnlockCandidateFromJobApplyAsync = createAsyncThunk(
    "UnlockCandidate/add",
    async ({ uuid }, { rejectWithValue }) => {
        try {
            const data = await UnlockCandidateFromJobApply(uuid);
            // console.log("Unlock API response data:", data);
            return data;
        } catch (error) {
            console.error("Error in UnlockCandidateAsync:", error);
            return rejectWithValue(error.message || "Failed to unlock candidate");
        }
    }
);

const UnlockCandidateFromJobApplySlice = createSlice({
    name: "UnlockCandidateFromJobApply",
    initialState,
    reducers: {
        resetUnlockState: (state) => {
            state.data = null;
            state.error = null;
            state.successMessage = null;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(UnlockCandidateFromJobApplyAsync.pending, (state) => {
                state.loading = true;
                state.error = null;
                state.successMessage = null;
            })
            .addCase(UnlockCandidateFromJobApplyAsync.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
                state.successMessage = "Candidate unlocked successfully";
                state.error = null;
            })
            .addCase(UnlockCandidateFromJobApplyAsync.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || "Failed to unlock candidate";
                state.successMessage = null;
            });
    },
});

export const { resetUnlockState } = UnlockCandidateFromJobApplySlice.actions;
export const selectJob = (state) => state.UnlockCandidateFromJobApply.data;
export const selectUnlockLoading = (state) => state.UnlockCandidateFromJobApply.loading;
export const selectUnlockError = (state) => state.UnlockCandidateFromJobApply.error;
export const selectUnlockSuccess = (state) => state.UnlockCandidateFromJobApply.successMessage;

export default UnlockCandidateFromJobApplySlice.reducer;